import React from 'react'
import {IconAdd} from '../Icons'
import {PageProps} from '../components/PageRouter'
import {Button, Container, Typography} from '@mui/material'
import {useSuspense} from '@data-client/react'
import {AclResource} from '../lib/model'
import {AclsTable} from '../components/Acl'
import {ActionHeader} from '../components'

export default function AclPage({session}: PageProps) {
  const acls = useSuspense(AclResource.getList, {scope: session.euid()})
  return (
    <Container maxWidth="md">
      <ActionHeader title="Access Rules">
        <Button href="./add" color="primary">
          <IconAdd /> &nbsp; Add
        </Button>
      </ActionHeader>
      <Typography variant="body1" sx={{my: 3, px: 2}}>
        Access Rules allow you to share Trips with Team Members as well as to those without a FotoLog account by using a token.
      </Typography>
      <AclsTable acls={acls} />
    </Container>
  )
}
